<script setup>
import { computed, watch, ref } from 'vue';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'next/polaris/ui/tabs';

const props = defineProps({
  tabs: {
    type: Array,
    default: () => [],
  },
  selectedTab: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['tabChange']);

const activeTab = ref(props.selectedTab);

watch(
  () => props.selectedTab,
  (value, oldValue) => {
    if (value !== oldValue) {
      activeTab.value = props.selectedTab;
    }
  }
);

const activeKey = computed(() => props.tabs[activeTab.value]?.key);

const onTabChange = key => {
  const index = props.tabs.findIndex(tab => tab.key === key);
  if (index < 0) return;
  activeTab.value = index;
  emit('tabChange', key);
};
</script>

<template>
  <Tabs
    :model-value="activeKey"
    activation-mode="manual"
    class="mt-5 gap-0"
    @update:model-value="onTabChange"
  >
    <div class="w-full overflow-x-auto">
      <TabsList variant="line" class="min-w-max">
        <TabsTrigger v-for="tab in tabs" :key="tab.key" :value="tab.key">
          {{ tab.name }}
          <span
            v-if="tab.showBadge && tab.count"
            class="tabular-nums type-polaris-caption text-polaris-muted-foreground"
          >
            {{ tab.count }}
          </span>
        </TabsTrigger>
      </TabsList>
    </div>
    <!-- Empty panels only so every tab's aria-controls points at a real element; the results live in the page below. -->
    <TabsContent
      v-for="tab in tabs"
      :key="tab.key"
      :value="tab.key"
      force-mount
      class="hidden"
    />
  </Tabs>
</template>
